// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-card {
  transition: all 0.3s ease;
  border-radius: 12px;
}

.product-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.15);
}

.card {
  border-radius: 12px;
}

button {
  transition: all 0.2s ease;
}

button:hover {
  transform: scale(1.05);
}`, "",{"version":3,"sources":["webpack://./src/styles/product.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".product-card {\r\n  transition: all 0.3s ease;\r\n  border-radius: 12px;\r\n}\r\n\r\n.product-card:hover {\r\n  transform: translateY(-6px);\r\n  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.card {\r\n  border-radius: 12px;\r\n}\r\n\r\nbutton {\r\n  transition: all 0.2s ease;\r\n}\r\n\r\nbutton:hover {\r\n  transform: scale(1.05);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
